module.exports = __webpack_public_path__ + "media/images/hiring_timeframe_collaboration-6b260104f1863a448e6752b60ffe4ac0.png";